/*
 * IMPORTS
 */
import React from 'react' // NPM: React.js library.
import { urlFor } from '../../client' // Helper from sanity.io for data.
import { Link } from 'react-router-dom' // Routing functions from react-router-som.
/*
 * STYLES
 */
import './index.scss'
import { images } from '../../constants'
import Carousel from 'react-bootstrap/Carousel'

/*
 * OBJECTS
 */

const Index = ({ serviceData }) => (
  <>
    {/* EXISTING DYNAMIC SERVICES FROM SANITY */}
    {
      serviceData[0]?.services.map(({ serviceHeading, service_point, main_content, images: serviceImages }) => (
        <div className='app__main-service'>
          <div className='headingWrapper'>
            <div style={{ 'background': `url(${images.ServiceIcon})` }} className='icon'/>
            <div className='heading'>
              {serviceHeading}
            </div>
          </div>
          <div className='content'>
            {main_content}
          </div>
          <div className='points'>
            <ul>
              {
                service_point.map(({ content }) => (
                  <li>
                    {content}
                  </li>
                ))
              }
            </ul>
            <Carousel interval={5000} fade={false} controls={false} pause={false} indicators={false}>
              {
                serviceImages.map((item, index) => (
                  <Carousel.Item key={index} className='item'>
                    <div style={{ 'background': `url(${item.main_image ? urlFor(item.main_image) : images.Placeholder})` }} className='service__images'/>
                  </Carousel.Item>
                ))
              }
            </Carousel>
          </div>
        </div>
      ))
    }

    {/* NEW STATIC RAILTRANS PMIS SECTION */}
    <div className='app__main-service'>
      <div className='headingWrapper'>
        {/* Reusing the ServiceIcon for consistency */}
        <div style={{ 'background': `url(${images.ServiceIcon})` }} className='icon'/>
        <div className='heading'>
          Project Management Information System (PMIS)
        </div>
      </div>

      <div className='content'>
        <p><strong>• Transforming Visibility • Control • Execution for Railway Projects</strong></p>
        <p>
          At Railgorithm®, we recognise that large-scale rail and metro software deployments demand rigorous planning, transparent execution and real-time insight. Our Project Management Information System (PMIS) is designed to deliver exactly that — a unified platform that brings together dashboards, workflows and collaboration to keep your projects on schedule, on budget and aligned with operational targets.
        </p>
        <p style={{ marginTop: '1rem' }}>
          By leveraging this PMIS, you gain clarity over complex projects, coordinate across multiple vendors and sites, anticipate and mitigate risks, and deliver software solutions on time and in full — reinforcing Railgorithm’s promise of “Software Solutions for Tomorrow’s Railway”.
        </p>
        <p style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>Why Choose RailTrans PMIS?</p>
      </div>

      <div className='points'>
        <ul>
          <li>
            <strong>Tailored for Railway Sector Complexity:</strong> Our system understands the nuances of rail/metro environments — depot management, rolling-stock diagnostics, secure connectivity, multi-site roll-outs — far beyond generic PM tools.
          </li>
          <li>
            <strong>Data-Driven Decision-Making:</strong> With real-time dashboards and alerts, you move from reactive to proactive project management.
          </li>
          <li>
            <strong>Scalable & Multi-geo Ready:</strong> Whether it’s one station upgrade or a metro-wide communications rollout, the PMIS scales to your needs.
          </li>
          <li>
            <strong>Integration with Our Service Portfolio:</strong> The PMIS aligns seamlessly with our consulting, custom development, upgrades & integration, and innovation services — offering a unified end-to-end solution.
          </li>
        </ul>
        {/* Carousel removed here as no images were provided for this specific section */}
      </div>
    </div>

    {/* ACHIEVEMENT SECTION */}
    <div className='achievement__contentWrapper'>
      <div className='achievement__content'>{serviceData[0]?.achievement}</div>
    </div>
    
    <Link to='/projects'>
      <div className='buttonWrapper'>
        <button>Know More</button>
      </div>
    </Link>
  </>
)

/*
 * EXPORTS
 */
export default Index